import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useProfileReadQuery } from "../store/api.ts";
import Loader from "./Loader.js";

const IsProfileCompleted = () => {
  const { data: me, isLoading, isError } = useProfileReadQuery();

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <Navigate to="/" replace />;
  }

  const isProfileIncomplete =
    !me?.face_shape || !me?.body_type || !me?.seasonal_color;

  if (isProfileIncomplete) {
    return <Navigate to="/quiz" replace />;
  }

  return <Outlet />;
};

export default IsProfileCompleted;
